export function formatLinkInstagram(user) {
  let instaLink = user.startsWith("@") ? user.slice(1) : user;
  const link = `https://www.instagram.com/${instaLink}`;
  return link;
}
